module.exports = __webpack_public_path__ + "static/media/info-icon.8f959d41.svg";